import React from 'react';
import DesktopLayout from "../../../../components/Page/components/DesktopLayout";
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { Box } from '@edreamsodigeo/prisma-design-system';
import { useDevice } from "../../../../clientState/hooks";
import MainHeader from "../../../../components/common/MainHeader";
import PropTypes from 'prop-types';
import Header, { NAVIGATION_TYPE } from "../../../../components/common/Header/Header";
import GreyInfoMessage from "../../../../components/common/GreyInfoMessage";
import FlightSelectorLCSection from "./FlightSelectorLCSection";
const FlightSelectorLCDesktopPage = ({
  bookingId,
  isPrime,
  legs,
  modifiable,
  onClickBackMenu,
  onClickLink
}) => {
  const {
    t
  } = useTranslation();
  const {
    gutter,
    columnWidth
  } = useDevice();
  return /*#__PURE__*/React.createElement(DesktopLayout, {
    mainHeader: /*#__PURE__*/React.createElement(MainHeader, {
      isPrime: isPrime,
      onClickLink: onClickLink,
      isLCFlow: true
    }),
    contentRight: /*#__PURE__*/React.createElement(Box, {
      mt: 124,
      mb: 104,
      maxWidth: columnWidth * 6 + gutter * 5
    }, /*#__PURE__*/React.createElement(FlightSelectorLCSection, {
      legs: legs,
      modifiable: modifiable,
      onClickBackToMenu: onClickBackMenu
    })),
    contentLeft: /*#__PURE__*/React.createElement(Header, {
      bookingId: bookingId,
      isPrime: isPrime,
      title: t('managebooking.modifytrip.changes.flightselector.heading.title'),
      onClickBack: onClickBackMenu,
      navigationType: NAVIGATION_TYPE.MENU
    }, /*#__PURE__*/React.createElement(Box, {
      pt: "1x_big",
      width: "75%"
    }, /*#__PURE__*/React.createElement(GreyInfoMessage, {
      text: t('managebooking.modifytrip.change.flightselector.message')
    })))
  });
};
FlightSelectorLCDesktopPage.prototype = {
  onClickLink: PropTypes.func
};
export default FlightSelectorLCDesktopPage;